import React from 'react';

interface MoneyLabelProps {
  amount: number;
  signed?: boolean;
  colorNegative?: boolean;
}

// see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
const integerFormatter = new Intl.NumberFormat('cs-CZ', {
  style: 'currency',
  currency: 'CZK',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

const decimalFormatter = new Intl.NumberFormat('cs-CZ', {
  style: 'currency',
  currency: 'CZK',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export function formatMoney(amount: number) {
  return integerFormatter.format(amount);
}

export function formatDecimalMoney(amount: number) {
  return decimalFormatter.format(amount);
}

export function DecimalMoneyLabel({ amount, colorNegative }: MoneyLabelProps) {
  const style = colorNegative && amount < 0 ? { color: 'red' } : undefined;
  return <span style={style}>{formatDecimalMoney(amount)}</span>;
}

export default function MoneyLabel({ amount, signed, colorNegative }: MoneyLabelProps) {
  const plusPrefix = signed && amount > 0 ? '+' : '';
  const style = colorNegative && amount < 0 ? { color: 'red' } : undefined;
  return <span style={style}>{plusPrefix + formatMoney(amount)}</span>;
}
